"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logging = void 0;
exports.logging = {
    userSearch: (id) => `user_action.location_page.search_${id}`,
    userShowMore: (id) => `user_action.location_page.showmore_${id}`
};
//# sourceMappingURL=logging.js.map